import { render, staticRenderFns } from "./followers-card.vue?vue&type=template&id=062a3248&"
import script from "./followers-card.vue?vue&type=script&lang=js&"
export * from "./followers-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports